import React from "react";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext";
import { useLanguage } from "../../contexts/LanguageContext";
import "../../styles/components/Layout/Navbar.css";
import LanguageSelector from "../LanguageSelector/LanguageSelector";

interface NavbarProps {}

const Navbar: React.FC<NavbarProps> = () => {
  const { isAuthenticated } = useAuthContext();
  const { t } = useLanguage();

  return (
    <nav className="navbar">
      <div className="logo">
        AETHELBUR <span>CHRONICLES</span>
      </div>

      <div className="nav-links">
        <Link to="/">
          <i className="fas fa-home"></i> {t("common", "nav.home")}
        </Link>
        <Link to="/History">
          <i className="fas fa-book-dead"></i> {t("common", "nav.history")}
        </Link>
        <Link to="/Characters">
          <i className="fas fa-dragon"></i> {t("common", "nav.characters")}
        </Link>
        <Link to="/World">
          <i className="fas fa-map-marked-alt"></i> {t("common", "nav.world")}
        </Link>
        <Link to="/download">
          <i className="fas fa-download"></i> {t("common", "nav.downloads")}
        </Link>
        <Link to="/Comunity">
          <i className="fas fa-users"></i> {t("common", "nav.community")}
        </Link>
      </div>

      <div className="user-actions">
        {!isAuthenticated && (
          <Link to="/register" className="btn register-btn">
            <i className="fas fa-user-plus"></i> {t("common", "nav.register")}
          </Link>
        )}
        {isAuthenticated && (
          <Link to="/profile" className="btn profile-btn">
            <i className="fas fa-user"></i> {t("common", "nav.profile")}
          </Link>
        )}
      </div>
      <div className="nav-utilities">
        <LanguageSelector />
        {/* ... user actions */}
      </div>
    </nav>
  );
};

export default Navbar;
